import { render, staticRenderFns } from "./AlumniTable.vue?vue&type=template&id=238f8d72&"
import script from "./AlumniTable.vue?vue&type=script&lang=js&"
export * from "./AlumniTable.vue?vue&type=script&lang=js&"
import style0 from "./AlumniTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports